global.htmx = require("htmx.org");
global.flowbite = require("flowbite");
